//#region src/kiosk_known_issue.ts
var KioskKnownIssue = /* @__PURE__ */ function(KioskKnownIssue) {
	KioskKnownIssue[KioskKnownIssue["IN_TRANSIT"] = 0] = "IN_TRANSIT";
	KioskKnownIssue[KioskKnownIssue["FAULTY_CHARGER"] = 1] = "FAULTY_CHARGER";
	KioskKnownIssue[KioskKnownIssue["AWOL"] = 2] = "AWOL";
	KioskKnownIssue[KioskKnownIssue["DEMO_DEVICE"] = 3] = "DEMO_DEVICE";
	KioskKnownIssue[KioskKnownIssue["REMOVED_FROM_MDM"] = 4] = "REMOVED_FROM_MDM";
	KioskKnownIssue[KioskKnownIssue["TEMPORARILY_UNUSED"] = 5] = "TEMPORARILY_UNUSED";
	return KioskKnownIssue;
}(KioskKnownIssue || {});
//#endregion
export { KioskKnownIssue };

//# sourceMappingURL=kiosk_known_issue.js.map